import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HeaderToolbar from './views/header/HeaderToolbar';
import SideNavigation from './views/sideNavigation/SideNavigation';
import React, { useEffect } from 'react';
import { initGA } from './util/Analytics';
import {
  StyledBackgroundImage,
  StyledContent,
  StyledHeader,
  StyledLayout,
  StyledOuterLayout,
} from './views/Styled/AppLayoutStyles';
import Sider from 'antd/es/layout/Sider';
import { defaultRoute, routes } from './routes';

const AppLayout = () => {
  const [collapsed, setCollapsed] = React.useState(false);

  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <StyledOuterLayout>
        <StyledHeader>
          <HeaderToolbar />
        </StyledHeader>
        <StyledBackgroundImage src={'Ship_BG.png'} alt='Background' />
        <StyledLayout>
          <Sider
            breakpoint='lg'
            collapsed={collapsed}
            collapsedWidth={100}
            onCollapse={(collapsed) => setCollapsed(collapsed)}
            collapsible
            theme='light'
            width={400}
            trigger={null}
            style={{ position: 'relative', background: 'transparent' }}
          >
            <SideNavigation />
          </Sider>
          <StyledContent>
            <Routes>
              {routes.map((route) => (
                <Route index={route.index === true} path={route.path} element={route.component} key={route.path} />
              ))}
              <Route element={defaultRoute.component} path={'*'} />
            </Routes>
          </StyledContent>
        </StyledLayout>
      </StyledOuterLayout>
    </Router>
  );
};

export default AppLayout;
